import { FullFormAction } from "../../../../Engine/Core/Store/FullFormAction";
import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { deleteIn, setIn } from "../../../../Helpers/ReduxStateHelpers";

import { InstanceNumberActionType } from "./instanceNumberActions";

export function instanceNumberReducer(state: FullFormState, action: FullFormAction): FullFormState {
    switch (action.type) {
        case InstanceNumberActionType.AddInstanceNumber: {
            const { bindingPath, instanceNumber } = action.payload;
            const newState = setIn(state, ["instanceNumber", bindingPath], instanceNumber);

            return newState;
        }
        case InstanceNumberActionType.RemoveInstanceNumber: {
            const { bindingPath } = action.payload;
            const newState = deleteIn(state, ["instanceNumber"], bindingPath);

            return newState;
        }
        default: {
            return state;
        }
    }
}
